// extracted by mini-css-extract-plugin
module.exports = {"form":"style_form__1hzHC","link":"style_link__32ksz","error":"style_error__dPbov"};